<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

import config from '@/config/config'

export default {
  data() {
    return {
      seatStatusCheckIntervalHandle: null,
      cancelTokenSource: null,
    }
  },
  computed: {
    ...mapGetters({
      token: 'auth/getToken',
      seatNo: 'seat/getSeatNo',
      error: 'seat/getError',
    }),
  },
  watch: {
    token(token) {
      // intervalが初期値の場合のみ処理
      if (this.seatStatusCheckIntervalHandle === null) {
        this.init()
      }
      // 終了処理
      if (token === '') {
        clearInterval(this.seatStatusCheckIntervalHandle)
        this.cancelTokenSource.cancel()
      }
    },
    error() {
      // Network Errorの場合、error.responseはundefinedになる
      if (!this.error.response) return // Network Error

      // 404の場合
      if (this.error.response.status === 404) {
        // 座席番号が初期値の場合、事前注文を開始
        if (this.seatNo === null) {
          this.stopSeatInterval()
          this.$store.dispatch('seat/setSeatNo', 0)
          this.$store.dispatch('modal/setShowingPreOrderWarningModal', true)
        }

        // 座席番号が0（事前注文状態）である場合、何もしない
        if (this.seatNo === 0) return

        // 404かつ、すでに座席番号が存在している場合
        if (this.seatNo > 0) {
          this.forceQuit()
        }
      } else {
        // エラーかつ404でない場合
        this.forceQuit()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchSeat: 'seat/fetchSeat',
    }),
    init() {
      this.getSeat()
      this.setSeatInterval()
    },
    setSeatInterval() {
      this.seatStatusCheckIntervalHandle = setInterval(() => {
        this.getSeat()
      }, config.seatStatusCheckInterval)
    },
    stopSeatInterval() {
      clearInterval(this.seatStatusCheckIntervalHandle)
    },
    async getSeat() {
      this.cancelTokenSource = axios.CancelToken.source()
      await this.fetchSeat(this.cancelTokenSource.token)
    },
    forceQuit() {
      this.stopSeatInterval()
      // セッションの強制終了を指定
      this.$store.dispatch('setting/setIsForceQuit', true)
      // スマホで注文を終了しますモーダルを出す
      this.$store.dispatch('modal/setShowingOrderQuittingModal', true)
    },
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
